import Vue from 'vue'
import { Notifier } from '@airbrake/browser'

let airbrake = {}

if (process.env.airbrakeKey) {
  airbrake = new Notifier({
    environment: process.env.environment,
    projectId: 310953,
    projectKey: process.env.airbrakeKey,
    keysBlocklist: [
      /token/,
    ],
  })

  // Add filter to clean URL
  airbrake.addFilter((notice) => {
    if (notice.context && notice.context.url) {
      try {
        const url = new URL(notice.context.url)
        const sensitiveParams = ['token', 'password', 'secret', 'key', 'api_key', 'access_token',
          'refresh_token', 'auth', 'credential', 'oauth']

        sensitiveParams.forEach((param) => {
          if (url.searchParams.has(param)) {
            url.searchParams.set(param, 'redacted')
          }
        })
        notice.context.url = url.toString()
      } catch (e) {
        // If URL parsing fails, leave it as is
      }
    }
    return notice
  })

  Vue.config.errorHandler = function (err, vm, info) {
    const user = vm?.$store?.$auth?.user
    const account = vm?.$store?.getters?.currentAccount

    const userData = {
      first_name: user?.first_name,
      last_name: user?.last_name,
      is_internal: user?.is_internal,
      role: user?.role,
    }

    const accountData = {
      name: account?.name,
      role: account?.role,
      level: account?.level,
    }

    airbrake.notify({
      error: err,
      params: { info, user: userData, currentAccount: accountData, buildVersion: process.env.buildHash },
    })
  }
}

export default function (_, inject) {
  inject('airbrake', airbrake)
}
